import { render, staticRenderFns } from "./AssigneesSelector.vue?vue&type=template&id=7d5a7fde"
import script from "./AssigneesSelector.vue?vue&type=script&lang=js"
export * from "./AssigneesSelector.vue?vue&type=script&lang=js"
import style0 from "./AssigneesSelector.vue?vue&type=style&index=0&id=7d5a7fde&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports